import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { InputWidthValues } from '../../../ui/gzInput';
import { InfoBoxSeverity } from '../../../ui/gzInfoBox/types';

export const templateDownloadWindow = document.createElement('template');

templateDownloadWindow.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper d-flex flex-column">
    <gz-text id="title" class="pb-4" fontSize="14"></gz-text>
    <div>
      <gz-form-field label="" id="download-path-field" stacked>
        <gz-text fontsize="12" id="download-path-information" class="mb-2"></gz-text>
        <gz-input gz-form-input id="download-path-input" type="text" placeholder="" inputwidth='400'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

        <gz-text fontsize="12" id="file-archive-details-information" class="pb-1"></gz-text>
       <div class="mt-6">
            <gz-text fontsize="12" id="password-protect-label" class="file-archive-details pb-1"></gz-text>
            <gz-toggle id="password-protect" gz-form-input></gz-toggle>
            <gz-form-field class='hidden mt-4 mb-7 password-protect-fields' label="" id="password-protect-fields" stacked>
                <gz-form-field label="" id="archive-password-form-field">
                    <gz-input gz-form-input id="archive-password"  type="password" placeholder="" inputwidth=${InputWidthValues.LARGE}>
                    </gz-input>
                     <gz-input-error></gz-input-error>
                     <gz-text fontsize="10" id="archive-password-details" class="archive-password-details"></gz-text>
                </gz-form-field>

                <gz-form-field id='repeat-password-form-field' >
                  <gz-input gz-form-input id="repeat-password"  type="password" placeholder="" inputwidth=${InputWidthValues.LARGE}>
                  </gz-input>
                   <gz-input-error></gz-input-error>
                </gz-form-field>

                 <gz-info-box severity="${InfoBoxSeverity.WARNING}" class="mt-3">
                    <gz-text fontsize="12" id="warning-password"></gz-text>
                </gz-info-box>
            </gz-form-field>
        </div>

  </div>
`;
